var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import { css, cx } from 'emotion';
export const LoadingLine = React.memo(function LoadingLine(_a) {
    var { widthRem = 5, randomizeWidthBy = 0, count = 1, color = '#F5F5F5', heightPx = 16, className, children } = _a, rest = __rest(_a, ["widthRem", "randomizeWidthBy", "count", "color", "heightPx", "className", "children"]);
    const times = new Array(count).fill(null);
    return (React.createElement(React.Fragment, null, times.map((_, index) => (React.createElement("div", Object.assign({}, rest, { key: index, className: cx(css `
                max-width: 100%;
                background: ${color};
                height: ${heightPx}px;
                width: ${randomizeWidthBy
            ? randomizeWithinRange(widthRem, randomizeWidthBy)
            : widthRem}rem;
              `, className) }), children)))));
});
export function randomizeWithinRange(value, range) {
    const lowerBound = value - range;
    const upperBound = value + range;
    return (Math.round((Math.random() * (upperBound - lowerBound) + lowerBound) * 100) /
        100);
}
//# sourceMappingURL=LoadingLine.js.map